<template>
  <div class="choice-company-page">
    <template v-if="listObj.xzt.length > 0">
      <div class="top-tips">您在小竹通有以下机构，请选择机构进入云校</div>
      <div class="company-list">
        <div
          class="company"
          @click="choiceCompany(item.id)"
          v-for="item in listObj.xzt"
          :key="item.id"
        >
          <!-- <img src="" alt="" class="c-logo"> -->
          <div
            class="c-logo"
            :style="{ backgroundImage: `url(${item.logoImage})` }"
          ></div>
          <div class="c-center">
            <div class="c-name">{{ item.companyName }}</div>
            <!-- <div class="c-city">湖南长沙</div> -->
          </div>
          <van-icon
            name="arrow"
            size="18"
            color="var(--g5)"
            style="vertical-align: text-bottom"
          />
        </div>
      </div>
    </template>

    <template v-if="listObj.face.length > 0">
      <div class="top-tips">您在脸到有以下机构，请选择机构进入云校</div>
      <div class="company-list">
        <div
          class="company"
          @click="choiceCompany(item.id)"
          v-for="item in listObj.face"
          :key="item.id"
        >
          <!-- <img src="" alt="" class="c-logo"> -->
          <div
            class="c-logo"
            :style="{ backgroundImage: `url(${item.logoImage})` }"
          ></div>
          <div class="c-center">
            <div class="c-name">{{ item.companyName }}</div>
            <!-- <div class="c-city">湖南长沙</div> -->
          </div>
          <van-icon
            name="arrow"
            size="18"
            color="var(--g5)"
            style="vertical-align: text-bottom"
          />
        </div>
      </div>
    </template>

    <div class="footer-btn">
      <span @click="$router.push('/baseOrganizationAdd?login=true')"
        >创建新机构</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "choice-company-page",
  data() {
    return {
      pageTitle: "选择机构",
      listObj: {
        xzt: [],
        face: [],
      },
    };
  },
  methods: {
    choiceCompany(id) {
      this.$router.push("/supplementInfo/" + id);
    },
  },
  created() {
    // productCode; 1: 云校 2：云课 3：小竹通 4：脸到 5：会员系统
    app.teacher.oCompanyList.forEach((item) => {
      if (item.productCode == 3) {
        this.listObj.xzt.push({
          id: item.id,
          companyName: item.companyName,
          logoImage: item.logoImage ? item.logoImage.url : "",
        });
      } else if (item.productCode == 4) {
        this.listObj.face.push({
          id: item.id,
          companyName: item.companyName,
          logoImage: item.logoImage ? item.logoImage.url : "",
        });
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.choice-company-page {
  color: var(--g6);
  .top-tips {
    padding: 20px 16px;
  }
  .company-list {
    .company {
      border-radius: 8px;
      margin: 0 12px 20px;
      padding: 16px;
      background-color: var(--white);
      display: flex;
      align-items: center;
      .c-logo {
        width: 48px;
        height: 48px;
        margin-right: 8px;
        border-radius: 50%;
        background-color: rgb(233, 241, 255);
        background-size: contain;
      }
      .c-center {
        flex: 1;
        // overflow: hidden;
        .c-name {
          color: var(--g8);
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
        }
        .c-city {
          margin-top: 4px;
        }
      }
    }
  }
  .footer-btn {
    color: #1890ff;
    text-align: center;
    padding-bottom: 20px;
  }
}
</style>
